<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-users-class" class="q-mb-sm" /> {{ $t('planned_vacancies') }}
        </div>

        <div class="row gutter-sm">
            <div class="col-xs-12 col-sm-12">
                <q-input v-model="company_branch_company_name" :float-label="$t('headquarter')" :error="$v.company_branch_company.$error" @input="$v.company_branch_company.$touch" @clear="removeHeadquarter" filter autofocus-filter clearable :disable="disableEditPlannedVacancies">
                    <q-autocomplete
                        @search="fetchHeadquarters"
                        @selected="selectHeadquarter"
                        :min-characters="1"
                        :max-results="100"
                    />
                </q-input>
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-select v-model="company_branch" :options="branches" :float-label="$t('branch')" :error="$v.company_branch.$error" @input="selectBranch" :disable="disableEditPlannedVacancies || disableEdit" />
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="fantasy" :float-label="$t('fantasy_name')" disable />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-input v-model="company_branch_document" :float-label="$t('store_document')" disable />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-input v-model="register" :float-label="$t('register_number')" disable />
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="presential_event_catalog_code" :float-label="$t('course_catalog_code')" :error="$v.presential_event_catalog.$error" @input="$v.presential_event_catalog.$touch" @clear="removeCatalogCode" filter autofocus-filter clearable :disable="disableEditPlannedVacancies || disableEdit">
                    <q-autocomplete
                        @search="fetchCatalogCodes"
                        @selected="selectCatalogCode"
                        :min-characters="1"
                        :max-results="100"
                    />
                </q-input>
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="presential_event_catalog_title" :float-label="$t('course_name')" disable />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-input v-model="qty_available_seats" :float-label="$t('total_vacancies')" :error="$v.qty_available_seats.$error" @input="$v.qty_available_seats.$touch" :disable="disableEditPlannedVacancies" />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-input v-model="qty_filled_seats" :float-label="$t('filled_vacancies')" disable />
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-field :helper="$t('the_quarter_must_be_filled_in_the_quarter_year_model_the_quarter_being_to_example')">
                    <q-input v-model="year_quarter" :float-label="$t('quarter')" :error="$v.year_quarter.$error" @input="$v.year_quarter.$touch" :disable="disableEditPlannedVacancies || disableEdit" />
                </q-field>
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'planned_vacancies' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" :disable="disableEditPlannedVacancies" />
            </div>
        </div>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, helpers } from 'vuelidate/lib/validators'

export default {
    name: 'AdminPlannedVacancy',

    i18nOptions: { namespaces: ['custom', 'common', 'presential', 'admin', 'organization'] },

    data() {
        return {
            company_label: '',
            company_branch: '',
            company_branch_not_edit: '',
            branches: [],
            fantasy: '',
            document: '',
            register: '',
            presential_event_catalog_code: '',
            presential_event_catalog: '',
            company: '',
            company_branch_document: '',
            presential_event_catalog_title: '',
            qty_available_seats: 0,
            qty_filled_seats: 0,
            year_quarter: '',
            year_quarter_not_edit: '',
            company_branch_company: '',
            company_branch_company_name: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            user_module_items: 'common/user_module_items'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        disableEditPlannedVacancies() {
            let item = this.user_module_items.find(e => e.slug === 'edit_presential_manager_seats')
            if (item) return !item.permission
            else return true
        },

        disableEdit() {
            if(this.id > 0) return true 
            else return false
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/presential_manager/admin_presential_seats/${this.id}/`, this.getHeader)
            .then(response => {
                this.company_branch = response.data.company_branch
                this.company_branch_edit = response.data.company_branch
                this.company_branch_company = response.data.company_branch_company
                this.company_branch_company_name = response.data.company_branch_company_name
                this.company_branch_document = response.data.company_branch_document
                this.presential_event_catalog = response.data.presential_event_catalog
                this.presential_event_catalog_code = response.data.presential_event_catalog_code
                this.presential_event_catalog_title = response.data.presential_event_catalog_title
                this.qty_available_seats = response.data.qty_available_seats
                this.qty_filled_seats = response.data.qty_filled_seats
                this.year_quarter = response.data.year_quarter
                this.year_quarter_not_edit = response.data.year_quarter

                this.fetchBranches()
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()
                if (this.id != 0) {
                    let data = {
                        'company_branch': this.company_branch,
                        'company_branch_company': this.company_branch_company,
                        'presential_event_catalog': this.presential_event_catalog,
                        'product_categories': this.product_categories,
                        'qty_available_seats': this.qty_available_seats,
                        'year_quarter': this.year_quarter_not_edit
                    }

                
                    this.$axios.put(`/presential_manager/admin_presential_seats/${this.id}/`, data, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('course_catalog_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.$router.push({ name: 'planned_vacancies' })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('course_catalog_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
                else {
                    let data = {
                        'company_branch': this.company_branch,
                        'company_branch_company': this.company_branch_company,
                        'presential_event_catalog': this.presential_event_catalog,
                        'product_categories': this.product_categories,
                        'qty_available_seats': this.qty_available_seats,
                        'year_quarter': this.year_quarter
                    }
                    this.$axios.post(`/presential_manager/admin_presential_seats/`, data, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('course_catalog_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.$router.push({ name: 'planned_vacancies' })
                    })
                    .catch(e => {
                        console.log(e)

                        if (e.response.data.seat_duplicate_error) {
                            this.$q.notify({
                                message: this.$t('there_is_already_a_vacancy_planned_for_this_dealership_course_quarter'),
                                type: 'negative',
                                icon: 'fal fa-ban'
                            })
                        }
                        else {
                            this.$q.notify({
                                message: this.$t('course_catalog_save_error'),
                                type: 'negative',
                                icon: 'fal fa-ban'
                            })
                        }
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
            }
        },

        fetchHeadquarters(terms, done) {
            this.$axios.get(`/admin_companies/companies/get_companies/?search=${terms}`, this.getHeader)
            .then(response => {
                let headquarters = response.data.map(element => (
                    {   ...element,
                        value: element.id,
                        label: `${element.name} / ${this.$t(element.company_type_label)} ${element.document && element.register ? `${element.document} - ${element.register}` : element.document ? element.document : element.register ? element.register : ''}`
                    }
                ))

                done(headquarters)
            })
            .catch(e => {
                done([])
                console.log(e)
            })
        },

        selectHeadquarter(item) {
            this.company_branch_company = item.id
            this.company_branch_company_name = item.label

            this.company_branch = ''
            this.company_branch_name = ''
            this.branches = []

            this.fetchBranches()
        },

        removeHeadquarter() {
            this.company_branch_company = ''
            this.company_branch_company_name = ''

            this.company_branch = ''
            this.company_branch_name = ''
            this.branches = []
        },

        fetchBranches() {
            this.$axios.get(`/admin_companies/branches/get_company_branches_filtered/?company=${this.company_branch_company}`, this.getHeader)
            .then(response => {
                this.branches = response.data.map(e => ({...e, label: `${e.name} - ${e.document}`, value: e.id}))
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                if (this.company_branch) {
                    this.selectBranch()
                }
            })
        },

        selectBranch() {
            this.$v.company_branch.$touch
            let branch = this.branches.find(e => e.value === this.company_branch)
            if (branch) {
                this.fantasy = branch.fantasy
                this.company_branch_document = branch.document
                this.register = branch.register
            }
        },

        fetchCatalogCodes(terms, done) {
            this.$axios.get(`/presential_manager/presential_catalogs/?search=${terms}`, this.getHeader)
            .then(response => {
                let catalog_codes = response.data.map(e => ({ ...e, value: e.code, label: `${e.code} - ${e.title}` }))
                done(catalog_codes)
            })
            .catch(e => {
                done([])
                console.log(e)
            })
        },

        selectCatalogCode(item) {
            this.presential_event_catalog = item.id
            this.presential_event_catalog_code = item.code
            this.presential_event_catalog_title = item.title
        },

        removeCatalogCode() {
            this.presential_event_catalog = ''
            this.presential_event_catalog_code = ''
            this.presential_event_catalog_title = ''
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        }
    },

    validations() {
        return {
            company_branch_company: {
                required
            },
            company_branch: {
                required
            },
            presential_event_catalog: {
                required
            },
            qty_available_seats: {
                required,
                availableSeats() {
                    return this.qty_available_seats >= this.qty_filled_seats && this.qty_available_seats > 0
                }
            },
            year_quarter: {
                required,
                isValid(value) {
                    return /([1-4]{1})\/([0-9]{4})/.test(value)
                }
            }
        }
    },

    created() {
        this.id = this.$route.params.id
        if (this.id != 0) this.fetchData()
    }
}
</script>

<style>

</style>
